import type { Pair } from '../messages';

/**
 * The add-by-link dialog: paste → parse → check the card → save. Field labels reuse `item.*`
 * and `playlists.*` wherever the Russian wording is byte-identical.
 */
export const dialog = {
  'dialog.pasteLink': ['Вставьте ссылку.', 'Paste a link.'],
  'dialog.parseFailed': ['Не удалось прочитать страницу.', 'We couldn’t read that page.'],
  'dialog.titleRequired': [
    'Дайте элементу название — его и видно в библиотеке.',
    'Give it a title — that is what your library shows.',
  ],
  'dialog.added': ['Добавлено в библиотеку', 'Added to your library'],
  'dialog.reviewTitle': ['Проверьте карточку', 'Check the card'],
  'dialog.addLink': ['Добавить ссылку', 'Add a link'],
  'dialog.reviewBody': [
    'Добавьте название и всё, что хотите запомнить об этой находке.',
    'Add a title and anything you want to remember about this find.',
  ],
  'dialog.addBody': [
    'На фильм, книгу, игру, статью — на всё, что хочется оставить рядом.',
    'A film, a book, a game, an article — anything worth keeping close.',
  ],
  'dialog.anotherLink': ['Другая ссылка', 'Another link'],
  'dialog.toLibrary': ['В библиотеку', 'To the library'],
  'dialog.reading': ['Читаем страницу…', 'Reading…'],
  'dialog.fetchData': ['Получить данные', 'Fetch details'],
  'dialog.fillManual': ['Заполнить вручную', 'Fill in by hand'],
  'dialog.manualSource': ['ручной ввод', 'typed by hand'],
  'dialog.existsGame': ['У вас уже есть эта игра — открыть', 'You already have this game — open'],
  'dialog.existsItem': ['Уже есть в библиотеке — открыть', 'Already saved — open'],
  'dialog.parsedOk': [
    'Данные считаны со страницы. Проверьте название и тип.',
    'Details came from the page. Check the title and type.',
  ],
  'dialog.manualOk': [
    'Ничего не подставляем — название пишете сами, остальное по желанию.',
    'Nothing auto-filled — you write the title, the rest is optional.',
  ],
  'dialog.titlePlaceholder': ['Как вы это назовёте', 'What you would call it'],
  'dialog.urlHint': [
    'Можно поправить, если редирект ушёл в сторонний домен.',
    'Fix it if the redirect landed on another domain.',
  ],
  'dialog.cover': ['Обложка', 'Cover'],
  'dialog.coverHint': ['URL картинки', 'Image URL'],
  'dialog.dupGame': ['Такая игра уже есть в библиотеке.', 'This game is already in your library.'],
  'dialog.dupItem': ['Такая ссылка уже есть в библиотеке.', 'This link is already in your library.'],
  'dialog.open': ['Открыть', 'Open'],
} satisfies Record<string, Pair>;
